var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "phone-content", style: _vm.phoneContentStyle },
    [
      _c(
        "div",
        {
          staticClass: "phone-top optional",
          class:
            ((_obj = { selected: "page" === _vm.selectedIndex }),
            (_obj[_vm.data.page.style.titleTextColor] = true),
            _obj),
          style: { backgroundColor: _vm.data.page.style.titleBackgroundColor },
          on: {
            click: function ($event) {
              return _vm.handelClickItem("page")
            },
          },
        },
        [
          _c(
            "p",
            {
              staticClass: "title",
              style: { color: _vm.data.page.style.titleTextColor },
            },
            [_vm._v(_vm._s(_vm.data.page.params.title))]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "phone-main" },
        [
          _c(
            "draggable",
            _vm._b(
              {
                class: [
                  "content",
                  { "is-dragging-new": !!_vm.draggingNewType },
                ],
                attrs: { list: _vm.data.items },
                on: { update: _vm.handelDragItem },
                nativeOn: {
                  dragover: function ($event) {
                    $event.preventDefault()
                    return _vm.handleDragOver($event)
                  },
                  drop: function ($event) {
                    $event.preventDefault()
                    return _vm.handleDropNewItem($event)
                  },
                  dragleave: function ($event) {
                    return _vm.handleDragLeave($event)
                  },
                },
              },
              "draggable",
              { animation: 120, filter: ".undrag" },
              false
            ),
            [
              _vm.draggingNewType
                ? _c("div", { staticClass: "drag-helper-tip" }, [
                    _vm._v("拖动到蓝色插槽后松开即可插入"),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.data.items, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "devise-item optional",
                    class: {
                      selected: index === _vm.selectedIndex,
                      undrag: _vm.inArray(item.type, _vm.undragList),
                      "drop-before": _vm.dragInsertIndex === index,
                    },
                    style: _vm.renderItemStyle(item),
                    on: {
                      click: function ($event) {
                        return _vm.handelClickItem(index)
                      },
                    },
                  },
                  [
                    _vm.dragInsertIndex === index
                      ? _c("div", { staticClass: "drop-slot" }, [
                          _c("span", { staticClass: "drop-slot__text" }, [
                            _vm._v("松开插入到这里"),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.type == "banner"
                      ? _c(
                          "div",
                          { staticClass: "diy-banner" },
                          [
                            _vm._l(item.data, function (dataItem, dataIdx) {
                              return _c("img", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: dataIdx <= 1,
                                    expression: "dataIdx <= 1",
                                  },
                                ],
                                key: index + "_" + dataIdx + "_img",
                                attrs: { src: dataItem.imgUrl },
                              })
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "dots",
                                class: item.style.btnShape,
                              },
                              _vm._l(item.data, function (dataItem, dataIdx) {
                                return _c("div", {
                                  key: index + "_" + dataIdx + "_dots",
                                  staticClass: "dots-item",
                                  style: { background: item.style.btnColor },
                                })
                              }),
                              0
                            ),
                          ],
                          2
                        )
                      : item.type == "image"
                      ? _c(
                          "div",
                          {
                            staticClass: "diy-image",
                            style: {
                              paddingBottom: item.style.paddingTop + "px",
                              background: item.style.background,
                            },
                          },
                          _vm._l(item.data, function (dataItm, dataIdx) {
                            return _c(
                              "div",
                              {
                                key: index + "_" + dataIdx,
                                staticClass: "item-image",
                                style: {
                                  padding:
                                    item.style.paddingTop +
                                    "px " +
                                    item.style.paddingLeft +
                                    "px 0",
                                  margin:
                                    item.style.marginTop +
                                    "px " +
                                    item.style.marginLeft +
                                    "px",
                                },
                              },
                              [_c("img", { attrs: { src: dataItm.imgUrl } })]
                            )
                          }),
                          0
                        )
                      : item.type == "window"
                      ? _c(
                          "div",
                          {
                            staticClass: "diy-window",
                            style: {
                              borderRadius: item.style.borderRadius + "px",
                              background: item.style.background,
                              padding:
                                item.style.paddingTop +
                                "px " +
                                item.style.paddingLeft +
                                "px",
                              margin:
                                item.style.marginTop +
                                "px " +
                                item.style.marginLeft +
                                "px",
                            },
                          },
                          [
                            item.style.layout > -1
                              ? _c(
                                  "ul",
                                  {
                                    staticClass: "data-list clearfix",
                                    class: "avg-sm-" + item.style.layout,
                                  },
                                  _vm._l(item.data, function (window, dataIdx) {
                                    return _c(
                                      "li",
                                      {
                                        key: index + "_" + dataIdx,
                                        staticClass: "data-item",
                                        style: {
                                          padding:
                                            item.style.paddingTop +
                                            "px " +
                                            item.style.paddingLeft +
                                            "px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "item-image" },
                                          [
                                            _c("img", {
                                              attrs: { src: window.imgUrl },
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _c("div", { staticClass: "display" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "display-left",
                                      style: {
                                        padding:
                                          item.style.paddingTop +
                                          "px " +
                                          item.style.paddingLeft +
                                          "px",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: { src: item.data[0].imgUrl },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "display-right" }, [
                                    item.data.length >= 2
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "display-right1",
                                            style: {
                                              padding:
                                                item.style.paddingTop +
                                                "px " +
                                                item.style.paddingLeft +
                                                "px",
                                            },
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: item.data[1].imgUrl,
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "display-right2" },
                                      [
                                        item.data.length >= 3
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "left",
                                                style: {
                                                  padding:
                                                    item.style.paddingTop +
                                                    "px " +
                                                    item.style.paddingLeft +
                                                    "px",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: item.data[2].imgUrl,
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.data.length >= 4
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "right",
                                                style: {
                                                  padding:
                                                    item.style.paddingTop +
                                                    "px " +
                                                    item.style.paddingLeft +
                                                    "px",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: item.data[3].imgUrl,
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                ]),
                          ]
                        )
                      : item.type == "video"
                      ? _c(
                          "div",
                          {
                            staticClass: "diy-video",
                            style: { padding: item.style.paddingTop + "px 0" },
                          },
                          [
                            _c(
                              "video",
                              {
                                style: { height: item.style.height + "px" },
                                attrs: {
                                  src: item.params.videoUrl,
                                  poster: item.params.poster,
                                  controls: "",
                                },
                              },
                              [_vm._v("您的浏览器不支持 video 标签")]
                            ),
                          ]
                        )
                      : item.type == "article"
                      ? _c(
                          "div",
                          {
                            staticClass: "diy-article",
                            style: {
                              borderRadius: item.style.borderRadius + "px",
                              padding:
                                item.style.paddingTop +
                                "px " +
                                item.style.paddingLeft +
                                "px",
                              margin:
                                item.style.marginTop +
                                "px " +
                                item.style.marginLeft +
                                "px",
                            },
                          },
                          [
                            _c("itemListStyle1", {
                              attrs: {
                                parentIndex: index,
                                itemStyle: item.style,
                                defaultData: _vm.getPreviewArticleList(item),
                              },
                            }),
                          ],
                          1
                        )
                      : item.type == "search"
                      ? _c(
                          "div",
                          {
                            ref: "search",
                            refInFor: true,
                            staticClass: "diy-search",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "inner",
                                class: item.style.searchStyle,
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "search-input",
                                    style: { textAlign: item.style.textAlign },
                                  },
                                  [
                                    _c("a-icon", {
                                      staticClass: "search-icon",
                                      attrs: { component: _vm.Icon.search },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(item.params.placeholder)),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        )
                      : item.type == "notice"
                      ? _c(
                          "div",
                          {
                            staticClass: "diy-notice",
                            style: { padding: item.style.paddingTop + "px 0" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "notice-body",
                                style: {
                                  background: item.style.background,
                                  color: item.style.textColor,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "notice__icon" },
                                  [
                                    _c("a-icon", {
                                      staticClass: "notice-icon",
                                      attrs: { component: _vm.Icon.volumeFill },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "notice__text flex-box oneline-hide",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(item.params.text)),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      : item.type == "navBar"
                      ? _c(
                          "div",
                          {
                            staticClass: "diy-navBar",
                            style: {
                              borderRadius: item.style.borderRadius + "px",
                              padding: item.style.paddingTop + "px 0",
                              background: item.style.background,
                              color: item.style.textColor,
                              padding:
                                item.style.paddingTop +
                                "px " +
                                item.style.paddingLeft +
                                "px",
                              margin:
                                item.style.marginTop +
                                "px " +
                                item.style.marginLeft +
                                "px",
                            },
                          },
                          [
                            _c(
                              "ul",
                              {
                                staticClass: "data-list clearfix",
                                class: "avg-sm-" + item.style.rowsNum,
                              },
                              _vm._l(item.data, function (dataItm, dataIdx) {
                                return _c(
                                  "li",
                                  {
                                    key: index + "_" + dataIdx,
                                    staticClass: "item-nav",
                                  },
                                  [
                                    _c("div", { staticClass: "item-image" }, [
                                      _c("img", {
                                        attrs: { src: dataItm.imgUrl },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      { staticClass: "item-text oneline-hide" },
                                      [_vm._v(_vm._s(dataItm.text))]
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        )
                      : item.type == "goods"
                      ? _c(
                          "div",
                          {
                            staticClass: "diy-goods",
                            style: { background: item.style.background },
                          },
                          [
                            _c(
                              "ul",
                              {
                                staticClass: "goods-list clearfix",
                                class: [
                                  "display__" + item.style.display,
                                  "column__" + item.style.column,
                                ],
                              },
                              _vm._l(
                                _vm.getPreviewGoodsList(item, index),
                                function (dataItm, dataIdx) {
                                  return _c(
                                    "li",
                                    {
                                      key: index + "_" + dataIdx,
                                      staticClass: "goods-item",
                                    },
                                    [
                                      item.style.column == 1
                                        ? [
                                            _c("div", { staticClass: "flex" }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "goods-item_left",
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: dataItm.goods_image,
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "goods-item_right",
                                                },
                                                [
                                                  item.style.show.includes(
                                                    "goodsName"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "goods-item_title twolist-hidden",
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                dataItm.goods_name
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "goods-item_desc",
                                                    },
                                                    [
                                                      item.style.show.includes(
                                                        "sellingPoint"
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "desc-selling_point oneline-hide",
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    dataItm.selling_point
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      item.style.show.includes(
                                                        "goodsSales"
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "desc-goods_sales oneline-hide",
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "已售" +
                                                                    _vm._s(
                                                                      dataItm.goods_sales
                                                                    ) +
                                                                    "件"
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "desc_footer",
                                                        },
                                                        [
                                                          item.style.show.includes(
                                                            "goodsPrice"
                                                          )
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "price_x",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "small-unit",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "¥"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        dataItm.goods_price_min
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          item.style.show.includes(
                                                            "linePrice"
                                                          ) &&
                                                          dataItm.line_price_min >
                                                            0
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "price_y",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "¥" +
                                                                      _vm._s(
                                                                        dataItm.line_price_min
                                                                      )
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        : [
                                            _c(
                                              "div",
                                              { staticClass: "goods-image" },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: dataItm.goods_image,
                                                  },
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "detail" },
                                              [
                                                item.style.show.includes(
                                                  "goodsName"
                                                )
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "goods-name twolist-hidden",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            dataItm.goods_name
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass: "detail-price",
                                                  },
                                                  [
                                                    item.style.show.includes(
                                                      "goodsPrice"
                                                    )
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "goods-price",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "small-unit",
                                                              },
                                                              [_vm._v("¥")]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  dataItm.goods_price_min
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item.style.show.includes(
                                                      "linePrice"
                                                    ) &&
                                                    dataItm.line_price_min > 0
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "line-price",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "small-unit",
                                                              },
                                                              [_vm._v("¥")]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  dataItm.line_price_min
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                    ],
                                    2
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        )
                      : item.type == "blank"
                      ? _c("div", {
                          staticClass: "diy-blank",
                          style: {
                            height: item.style.height + "px",
                            background: item.style.background,
                          },
                        })
                      : item.type == "guide"
                      ? _c(
                          "div",
                          {
                            staticClass: "diy-guide",
                            style: {
                              padding: item.style.paddingTop + "px 0",
                              background: item.style.background,
                            },
                          },
                          [
                            _c("p", {
                              staticClass: "line",
                              style: {
                                borderTopWidth: item.style.lineHeight + "px",
                                borderTopColor: item.style.lineColor,
                                borderTopStyle: item.style.lineStyle,
                              },
                            }),
                          ]
                        )
                      : item.type == "service"
                      ? _c(
                          "div",
                          {
                            staticClass: "diy-service",
                            style: { opacity: item.style.opacity / 100 },
                          },
                          [
                            _c("div", { staticClass: "service-icon" }, [
                              _c("img", {
                                staticClass: "image",
                                attrs: { src: item.params.image, alt: "" },
                              }),
                            ]),
                          ]
                        )
                      : item.type == "richText"
                      ? _c("div", {
                          staticClass: "diy-richText",
                          style: {
                            background: item.style.background,
                            padding:
                              item.style.paddingTop +
                              "px " +
                              item.style.paddingLeft +
                              "px",
                            margin:
                              item.style.marginTop +
                              "px " +
                              item.style.marginLeft +
                              "px",
                          },
                          domProps: { innerHTML: _vm._s(item.params.content) },
                        })
                      : item.type == "tabList"
                      ? _c(
                          "div",
                          {
                            staticClass: "diy-tabList",
                            style: {
                              borderRadius: item.style.borderRadius + "px",
                              padding:
                                item.style.paddingTop +
                                "px " +
                                item.style.paddingLeft +
                                "px",
                              margin:
                                item.style.marginTop +
                                "px " +
                                item.style.marginLeft +
                                "px",
                            },
                          },
                          [
                            _c("div", [
                              _c("div", { staticClass: "tab-bar clearfix" }, [
                                _c("span", { staticClass: "active" }, [
                                  _vm._v("tab1"),
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v("tab2")]),
                                _vm._v(" "),
                                _c("span", [_vm._v("tab3")]),
                              ]),
                            ]),
                            _vm._v(" "),
                            item.style.listStyle === 1
                              ? _c("itemListStyle1", {
                                  attrs: {
                                    parentIndex: index,
                                    itemStyle: item.style,
                                    defaultData:
                                      _vm.getPreviewArticleList(item),
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item.style.listStyle === 2
                              ? _c("itemListStyle2", {
                                  attrs: {
                                    parentIndex: index,
                                    itemStyle: item.style,
                                    defaultData:
                                      _vm.getPreviewArticleList(item),
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : item.type == "stickyTabList"
                      ? _c(
                          "div",
                          {
                            staticClass: "diy-stickyTabList",
                            style: {
                              borderRadius: item.style.borderRadius + "px",
                              padding:
                                item.style.paddingTop +
                                "px " +
                                item.style.paddingLeft +
                                "px",
                              margin:
                                item.style.marginTop +
                                "px " +
                                item.style.marginLeft +
                                "px",
                            },
                          },
                          [
                            _c("div", [
                              _c("div", { staticClass: "tab-bar clearfix" }, [
                                _c("span", { staticClass: "active" }, [
                                  _vm._v("tab1"),
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v("tab2")]),
                                _vm._v(" "),
                                _c("span", [_vm._v("tab3")]),
                              ]),
                            ]),
                            _vm._v(" "),
                            item.style.listStyle === 1
                              ? _c("itemListStyle1", {
                                  attrs: {
                                    parentIndex: index,
                                    itemStyle: item.style,
                                    defaultData:
                                      _vm.getPreviewArticleList(item),
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item.style.listStyle === 2
                              ? _c("itemListStyle2", {
                                  attrs: {
                                    parentIndex: index,
                                    itemStyle: item.style,
                                    defaultData:
                                      _vm.getPreviewArticleList(item),
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "btn-edit-del" }, [
                      _c(
                        "div",
                        {
                          staticClass: "btn-copy",
                          on: {
                            click: function ($event) {
                              return _vm.handleCopyItem(index)
                            },
                          },
                        },
                        [_vm._v("复制")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "btn-del",
                          on: {
                            click: function ($event) {
                              return _vm.handleDeleleItem(index)
                            },
                          },
                        },
                        [_vm._v("删除")]
                      ),
                    ]),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.dragInsertIndex === _vm.data.items.length
                ? _c("div", { staticClass: "drop-tail-line" }, [
                    _c("span", { staticClass: "drop-slot__text" }, [
                      _vm._v("松开插入到这里"),
                    ]),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }